// extracted by mini-css-extract-plugin
module.exports = {"button":"scrollWidget_button__dFmMO","show":"scrollWidget_show__thqR6","hide":"scrollWidget_hide__Xu5X1"};